import store from 'store/store';
var callback = function (newValue, oldValue) {
    store.previousHeaderVariants.set(oldValue.length ? oldValue : newValue);
};
store.headerVariants.listen(callback);
